var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseBanner',{staticClass:"trial-banner"},[_c('p',[_vm._v(_vm._s(_vm.trialStatus))]),_c('RouterLink',{attrs:{"to":"select-plan"}},[_c('RButton',{attrs:{"size":"sm"}},[_vm._v("Select plan")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }